<div class="def-header component-container" [class]="controlAction" [class.odm-home]="home" [class.odm-away]="!home" [style.background-color]="bgColor">
  <div class="logo" [style]="getBgr()"></div>
  <div class="middle">
    <div class="team">{{home ? broadcast.config.homeConfig.fullName : broadcast.config.awayConfig.fullName}}</div>
    <div class="header">{{ broadcast?.config?.skinId === 'ODM' ? 'OBRANA' : 'DEFENSE:' }}</div>
  </div>
  <div class="logo" [style]="getBgr()"></div>
</div>
<ng-container *ngFor="let player of defense">
  <app-possition-player *ngIf="player && player.position > 0 && show[player.position]" [player]="player"
                        [class]="'pos-' + player.position" [class.odm-home]="home" [class.odm-away]="!home"
                        [bgColor]="bgColor" [skipPortraits]="broadcast?.config.skipPortraits">
  </app-possition-player>
</ng-container>
